
import { useState, useEffect, Suspense, useRef } from 'react';
import StickyAnchorNav from '../../../components/common/StickyAnchorNav';
import MobileConversionBar from '../../../components/common/MobileConversionBar';
import ScrollProgressIndicator from '../../../components/common/ScrollProgressIndicator';
import HeroSection from './HeroSection';
import TrustBar from './TrustBar';
import ProblemAgitation from './ProblemAgitation';
import SolutionComparison from './SolutionComparison';
import ProgramBenefits from './ProgramBenefits';
import SpecializationSelector from './SpecializationSelector';
import FeeStructure from './FeeStructure';
import SuccessStories from './SuccessStories';
import FAQSection from './FAQSection';
import FinalConversion from './FinalConversion';
import Footer from './Footer';
import Learn_ai from './learn_ai/Learn_ai';
import Program_takeway from './program_takeway/Program_takeway';
import Certificate from './certificate/Certificate';
import Dpu_alumni from './dpu_alumni/Dpu_alumni';
import Student_Feedback from './student_feedback/Student_Feedback';
import Hiring_Partners from './hiring_partners/Hiring_Partners';
import Eligibility_Section from './eligibility_section/Eligibility_Section';
import Enquiry_Form_Modal from '../../enquiry_form_modal/Enquiry_Form_Modal'

const LandingPageInteractive = () => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const scrollToApply = () => {
    const element = document.querySelector('#apply-now');
    if (element) {
      element?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToFees = () => {
    const element = document.querySelector('#fees-emi');
    if (element) {
      element?.scrollIntoView({ behavior: 'smooth' });
    }
  };


      const [isNavOpen, setIsNavOpen] = useState(false);
  const [showStickyModal, setShowStickyModal] = useState(false);
  const [modalTriggered, setModalTriggered] = useState(false);

  const alumniRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!alumniRef.current || modalTriggered) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShowStickyModal(true);
          setModalTriggered(true);
          observer.disconnect();
        }
      },
      { threshold: 0.4 }
    );

    observer.observe(alumniRef.current);

    return () => observer.disconnect();
  }, [modalTriggered]);


  return (
    <div className="min-h-screen bg-background">
      <Suspense fallback={<div className="h-20 bg-background" />}>
        <StickyAnchorNav isOpen={isNavOpen} onToggle={() => setIsNavOpen(!isNavOpen)} />
      </Suspense>
      
      <ScrollProgressIndicator showPercentage={false} />
      
      <HeroSection onApplyClick={scrollToApply} onFeeDetailsClick={scrollToFees} />
      
      <TrustBar />

      <Learn_ai />

      <Program_takeway />

      <Eligibility_Section/>

      <Certificate />

       <div ref={alumniRef}>
        <Dpu_alumni />
      </div>

      <Student_Feedback />
      
      <ProblemAgitation />
      
      <SolutionComparison />

      <Hiring_Partners />
      
      {/* <ProgramBenefits /> */}
      
      <SpecializationSelector />
      
      <FeeStructure />
      
      {/* <SuccessStories /> */}
      
      <FAQSection />
      
      <FinalConversion />
      
      <Footer />
      
      <MobileConversionBar isVisible={true} />

      
      <Enquiry_Form_Modal
          show={showStickyModal}
          onHide={() => {
            setShowStickyModal(false);
          }}
        />
    </div>
  );
};

export default LandingPageInteractive;